const TabHeader = ({ ExtraButtons, prefix, children, style, bold }) => {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      padding: bold ? "0 20px" : "16px 20px 0",
      borderBottom: "1px solid #f0f0f0",
      background: bold ? "#fff" : "transparent",
      ...style,
    }}>
      {bold && (
        <style>{`
          .modern-tab-link {
            display: inline-flex; align-items: center; justify-content: center; gap: 7px;
            padding: 12px 18px; font-size: 0.88rem; font-weight: 600;
            color: #9e9e9e; text-decoration: none !important;
            border-bottom: 3px solid transparent; width: 100%;
            transition: color 0.15s, border-color 0.15s;
            white-space: nowrap; cursor: pointer;
          }
          .modern-tab-link:hover { color: #1a73e8; }
          .modern-tab-link.active { color: #1a73e8 !important; border-bottom-color: #1a73e8 !important; }
        `}</style>
      )}
      <ul className="nav" id={prefix + "-tab"} role="tablist"
        style={{ gap: bold ? 0 : "4px", marginBottom: 0, padding: 0, listStyle: "none", display: "flex", flex: bold ? 1 : undefined }}>
        {children}
      </ul>
      <div style={{ marginLeft: "auto" }}>
        {ExtraButtons ? <ExtraButtons /> : null}
      </div>
    </div>
  );
};

export default TabHeader;
